import { MockSearchCustomerItem, MockSearchCustomerPaginatedData } from './formModel';

export const mockCustomerData: MockSearchCustomerPaginatedData = {
  pageSize: 2,
  pages: [
    [
      {
        id: '1',
        firstName: 'John',
        lastName: 'Smith',
        dateOfBirth: '12/07/1986',
        address: '123 Main Street',
        countryCode: '+353',
        mobileNumber: '1 234 5678',
        email: 'john.smith@example.com',
      },
      {
        id: '2',
        firstName: 'Sarah',
        lastName: 'Johnson',
        dateOfBirth: '03/02/1988',
        address: '456 Oak Avenue',
        countryCode: '+353',
        mobileNumber: '21 987 6543',
        email: 'sarah.johnson@example.com',
      },
    ],
    [
      {
        id: '3',
        firstName: 'Michael',
        lastName: "O'Brien",
        dateOfBirth: '25/09/1990',
        address: '789 Elm Road',
        countryCode: '+353',
        mobileNumber: '61 555 1234',
        email: 'michael.obrien@example.com',
      },
      {
        id: '4',
        firstName: 'Emma',
        lastName: 'Walsh',
        dateOfBirth: '14/05/1992',
        address: '321 Maple Drive',
        countryCode: '+353',
        mobileNumber: '91 222 3333',
        email: 'emma.walsh@example.com',
      },
    ],
    [
      {
        id: '5',
        firstName: 'David',
        lastName: 'Murphy',
        dateOfBirth: '08/01/1994',
        address: '654 Pine Lane',
        countryCode: '+48',
        mobileNumber: '51 444 5678',
        email: 'david.murphy@example.com',
      },
      {
        id: '6',
        firstName: 'Lisa',
        lastName: 'Ryan',
        dateOfBirth: '20/08/1995',
        address: '987 Cedar Street',
        countryCode: '+49',
        mobileNumber: '21 666 7777',
        email: 'lisa.ryan@example.com',
      },
    ],
  ],
};

export const getMockSearchResults = (): MockSearchCustomerItem[] => {
  return mockCustomerData.pages.flat();
};
